import { useState } from 'react';

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      text: 'Necesitábamos vaciar el piso de mi madre en Castelldefels de forma urgente y JUSTCLEAN nos solucionó todo en 48 horas. Servicio impecable, discreto y muy profesional. Totalmente recomendable.',
      author: 'María González',
      location: 'Castelldefels Centro',
      rating: 5,
    },
    {
      text: 'Como administrador de fincas, trabajo con JUSTCLEAN regularmente para vaciados de pisos. Siempre cumplen los plazos, son muy profesionales y dejan todo impecable. Excelente relación calidad-precio.',
      author: 'Carlos Martínez',
      location: 'Gavà',
      rating: 5,
    },
    {
      text: 'Contraté sus servicios para un caso de síndrome de Diógenes. El equipo fue extremadamente respetuoso y discreto. Hicieron un trabajo excepcional en una situación muy delicada. Gracias por todo.',
      author: 'Ana Rodríguez',
      location: 'Viladecans',
      rating: 5,
    },
  ];

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/a3f35ddc44f6eac96369571c4c03783e.jpg"
              alt="Cliente satisfecho"
              className="w-full h-96 object-cover object-top rounded-[32px] border-2 border-white shadow-card"
              loading="lazy"
              decoding="async"
              width="600"
              height="600"
            />
          </div>

          <div className="lg:col-span-3">
            <span className="text-sm text-gray-medium mb-4 block">(Opinión Verificada)</span>
            
            <h2 className="text-4xl md:text-5xl font-bold mb-8">
              <span className="text-graphite">Lo que dicen</span><br />
              <span className="text-gray-light">nuestros clientes</span>
            </h2>

            <div className="mb-6">
              <div className="flex mb-4">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent text-xl"></i>
                ))}
              </div>
              <p className="text-lg text-gray-dark leading-relaxed mb-6 italic">
                "{testimonials[currentIndex].text}"
              </p>
              <div>
                <p className="font-bold text-graphite">— {testimonials[currentIndex].author}</p>
                <p className="text-sm text-gray-medium">{testimonials[currentIndex].location}</p>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <button
                onClick={handlePrev}
                className="w-12 h-12 rounded-full bg-silver-light flex items-center justify-center hover:bg-silver transition-all cursor-pointer"
                aria-label="Anterior testimonio"
              >
                <i className="ri-arrow-left-line text-gray-dark text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-12 h-12 rounded-full bg-primary flex items-center justify-center hover:bg-primary-dark transition-all cursor-pointer"
                aria-label="Siguiente testimonio"
              >
                <i className="ri-arrow-right-line text-white text-xl"></i>
              </button>
              <span className="text-sm text-gray-medium ml-4">
                {currentIndex + 1} / {testimonials.length}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
